import React, { ReactElement } from 'react';

import { displayCompetenzaColore } from '../utils';
import { useCompetenza } from '../reducers';
import GroupedMultipleSelect from './GroupedMultipleSelect';
import { COMPETENZA_TIPOLOGIA } from '../globals/auto-enums';

interface ownProps {
  name: string,
  displayName?: string,
  help_text?: string | ReactElement,
}

const CompetenzaSelector = (props: ownProps) => {
  const competenze = useCompetenza(props);
  return (
    <GroupedMultipleSelect
      {...props}
      elements={competenze}
      getGroup={comp => comp.tipologia}
      groupToColor={displayCompetenzaColore}
      displayGroup={group => COMPETENZA_TIPOLOGIA.find(type => type.id === group)?.display || group}
      displayElem={comp => comp.nome}
    />
  )
}

export default CompetenzaSelector;
